import { ScheduleFormComponent } from './schedule-form/schedule-form.component';
import { Component, OnInit, Injectable, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/_services';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ScheduleService } from './schedule.service';
import { ToastrService } from 'ngx-toastr';
import { NgbDateParserFormatter, NgbDateStruct, NgbDateAdapter, NgbModal, NgbTimeAdapter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapter } from '@app/execution-history/testsuite/testsuite.component';
import { DatePipe } from '@angular/common';
import { CronExpressionModalComponent } from './cron-expression-modal/cron-expression-modal.component';
import { SharedUtilService } from '../shared-util.service';
import { constants } from '@assets/data/constants';
import { OptionBarComponent } from '../option-bar/option-bar.component';
import { Title } from '@angular/platform-browser';
import { Location } from "@angular/common";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';


@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '-';
  parse(value: string): NgbDateStruct {
    let result: NgbDateStruct;
    if (value) {
      const date = value.split(this.DELIMITER);
      result = {
        year: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        day: parseInt(date[2], 10)
      };
    }
    return result;
  }

  format(date: NgbDateStruct): string {
    let result = '';
    if (date) {
      if (date.day < 10) { result = result + '0'; }
      result = result + date.day + this.DELIMITER;
      if (date.month < 10) { result = result + '0'; }
      result = result + date.month;
      result = result + this.DELIMITER + date.year;
    }
    return result;
  }
}

@Injectable()
export class CustomTimeParser extends NgbTimeAdapter<string> {

  fromModel(value: string): NgbTimeStruct {
    if (!value) {
      return null;
    }
    const split = value.split(':');
    return {
      hour: parseInt(split[0], 10),
      minute: parseInt(split[1], 10),
      second: parseInt(split[2], 10)
    };
  }

  toModel(time: NgbTimeStruct) {
    if (!time) {
      return null;
    }
    return `${this.pad(time.hour)}:${this.pad(time.minute)}:${this.pad(time.second)}`;
  }

  private pad(i: number): string {
    return i < 10 ? `0${i}` : `${i}`;
  }
}

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.less'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: NgbTimeAdapter, useClass: CustomTimeParser },
    DatePipe
  ]
})

export class ScheduleComponent implements OnInit {

  @ViewChild(OptionBarComponent, { static: false }) child: OptionBarComponent;

  moduleDetails;
  moduleType: string;
  newScheduleForm: FormGroup;
  scheduledExecutions: any;
  scheduledExecutionJobResults: any;
  showScheduledExecutionJobResults = false;
  selectedScheduleName: any;
  selectedScehduleId: any;
  isEdit = false;
  isCollapsed: boolean;
  environmentMapList: any;
  page = 1;
  pageSize = 10;
  collectionSize: any;
  toggleExecutionJobResults = true;
  totalResults: any;
  minDate;
  executionStatuses: any;
  filterForm: FormGroup;
  jobResults: any;
  moreData:boolean = false;
  setDeleteAll = false;
  isAllScheduleSelected = false;
  originalComponents = [];
  onActiveChangeTriggered = false;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private AuthService: AuthenticationService,
    private scheduleService: ScheduleService,
    private toastr: ToastrService,
    private router: Router,
    private sharedUtilService: SharedUtilService,
    private titleService: Title,
    private location: Location
  ) {}

  ngOnInit() {
    this.route.params.subscribe(() => {
      this.moduleType = this.route.snapshot.data.type;
      this.moduleDetails = this.route.snapshot.data.details.response;
      this.executionStatuses = JSON.parse(localStorage.getItem('about')).executionStatuses.slice(0, 2)
      this.AuthService.getUserRoleByProject(this.moduleDetails.role); /* Role */
      this.getScheduledExecutions();
      this.statusFilterForm();

      this.titleService.setTitle(this.moduleType + ' | ' + this.moduleDetails.name);
    });
  }

  statusFilterForm() {
    this.filterForm = this.formBuilder.group({
      executionStatus: new FormControl(),
    })
  }

  clickToOpenSchedule() {
    this.isEdit = false;
    const modalRef = this.modalService.open(ScheduleFormComponent, {
      ariaLabelledBy: "modal-basic-title",
      backdrop: "static",
      windowClass: "confirm-modal",
      centered: true,
      size: "xl",
    });

    const data = {
      moduleType: this.moduleType,
      moduleDetails: this.moduleDetails,
      minDate: this.minDate,
      child: this.child,
      isEdit: this.isEdit,
    };

    modalRef.componentInstance.fromParent = data;
    modalRef.componentInstance.scheduledExecutionTrigger.subscribe(() => {
      this.getScheduledExecutions();
    });
    return modalRef.result;
  }

  getScheduledExecutions() {
    this.scheduledExecutions = null;
    this.isAllScheduleSelected = false;
    this.setDeleteAll = false;
    if (this.moduleType === 'ENDPOINT') {
      this.scheduleService.getEndPointSchedules(this.moduleDetails['id']).subscribe(data => {
        if (data.code === 200) {
          this.scheduledExecutions = data.response;
          this.originalComponents = JSON.parse(JSON.stringify(this.scheduledExecutions));
        }
      });
    } else if (this.moduleType === 'TESTCASE') {
      this.scheduleService.getTestCaseSchedules(this.moduleDetails['id']).subscribe(data => {
        if (data.code === 200) {
          this.scheduledExecutions = data.response;
          this.originalComponents = JSON.parse(JSON.stringify(this.scheduledExecutions));
        }
      });
    } else if (this.moduleType === 'TESTSUITE') {
      this.scheduleService.getTestSuiteSchedules(this.moduleDetails['id']).subscribe(data => {
        if (data.code === 200) {
          this.scheduledExecutions = data.response;
          this.originalComponents = JSON.parse(JSON.stringify(this.scheduledExecutions));
        }
      });
    } else {
      this.scheduleService.getMasterSuiteSchedules(this.moduleDetails['id']).subscribe(data => {
        if (data.code === 200) {
          this.scheduledExecutions = data.response;
          this.originalComponents = JSON.parse(JSON.stringify(this.scheduledExecutions));
        }
      });
    }
  }

  getScheduledExecutionResults(){
    this.showScheduledExecutionJobResults = true;
      this.selectedScehduleId = this.selectedScehduleId;
      const collection = {
        page: (this.page - 1) || 0,
        size: this.pageSize || 10
      };

      const executionType = this.getExecutionEntityType(this.moduleType);

      this.scheduleService.getResults(this.selectedScehduleId, collection.page, collection.size, executionType).subscribe(data => {
        if (data.code === 200) {
          data.response.map((executionJobResults) => {
            this.scheduledExecutionJobResults.push(executionJobResults);
          });
        this.toggleExecutionJobResults = false;
        this.showScheduledExecutionJobResults = true;
        this.jobResults = this.scheduledExecutionJobResults;
        if (data.response.length < collection.size || data.response.length === 0) {
          this.moreData = false;
        } else {
          this.moreData = true;
        }
      } else if(data.code === 204) {
        if(this.scheduledExecutionJobResults.length > 0) {
          this.moreData = false;
        } else {
          this.toastr.warning(data.message);
          this.toggleExecutionJobResults = true;
          this.showScheduledExecutionJobResults = false;
          this.scheduledExecutionJobResults = null;
          this.moreData = false;
        }
      } else {
        this.toastr.warning(data.message);
        this.toggleExecutionJobResults = true;
        this.showScheduledExecutionJobResults = false;
        this.scheduledExecutionJobResults = null;
        this.moreData = false;
      }
    });
  }

  getScheduledExecutionResultsByStatus(){
    this.showScheduledExecutionJobResults = true;
      this.selectedScehduleId = this.selectedScehduleId;
      const collection = {
        page: (this.page - 1) || 0,
        size: this.pageSize || 10
      };
  
      const executionType = this.getExecutionEntityType(this.moduleType);
  
      this.scheduleService.getResultsByStatus(this.selectedScehduleId, collection.page, collection.size, this.filterForm.controls.executionStatus.value, executionType).subscribe(data => {
        if (data.code === 200) {
            data.response.map((executionJobResults) => {
              this.scheduledExecutionJobResults.push(executionJobResults);
            });
          this.toggleExecutionJobResults = false;
          this.showScheduledExecutionJobResults = true;
          this.jobResults = this.scheduledExecutionJobResults;
          if (data.response.length < collection.size|| data.response.length === 0) {
            this.moreData = false;
          } else {
            this.moreData = true;
          }
        } else if(data.code === 204) {
          if(this.scheduledExecutionJobResults.length > 0) {
            this.moreData = false;
          } else {
            this.toastr.warning(data.message);
            this.toggleExecutionJobResults = true;
            this.showScheduledExecutionJobResults = false;
            this.scheduledExecutionJobResults = null;
            this.moreData = false;
          }
        } else {
          this.toastr.warning(data.message);
          this.toggleExecutionJobResults = true;
          this.showScheduledExecutionJobResults = false;
          this.scheduledExecutionJobResults = null;
          this.moreData = false;
        }
      });
  }

  getScheduledExecutionJobResults(id) {
    this.filterForm.reset();
    this.scheduledExecutionJobResults = null;
    this.showScheduledExecutionJobResults = true;
    this.selectedScehduleId = id;
    this.page = 1;
    const collection = {
      page: (this.page - 1) || 0,
      size: this.pageSize || 10
    };

    const executionType = this.getExecutionEntityType(this.moduleType);

    this.scheduleService.getResults(id, collection.page, collection.size, executionType).subscribe(data => {
      if (data.code === 200) {
        this.scheduledExecutionJobResults = data.response;
        this.toggleExecutionJobResults = false;
        this.showScheduledExecutionJobResults = true;
        this.jobResults = this.scheduledExecutionJobResults;
        if (data.response.length < collection.size || data.response.length === 0) {
          this.moreData = false;
        } else {
          this.moreData = true;
        }
      } else {
        this.toastr.warning(data.message);
        this.toggleExecutionJobResults = true;
        this.showScheduledExecutionJobResults = false;
        this.scheduledExecutionJobResults = null;
        this.moreData = false;
      }
    });
  }

  getScheduledExecutionJobResultsByStatus(id) {
    this.scheduledExecutionJobResults = null;
    this.showScheduledExecutionJobResults = true;
    this.selectedScehduleId = id;
    this.page = 1;
    const collection = {
      page: (this.page - 1) || 0,
      size: this.pageSize || 5
    };

    const executionType = this.getExecutionEntityType(this.moduleType);

    this.scheduleService.getResultsByStatus(this.selectedScehduleId, collection.page, collection.size, this.filterForm.controls.executionStatus.value, executionType).subscribe(data => {
      if (data.code === 200) {
        this.scheduledExecutionJobResults = data.response;
        this.toggleExecutionJobResults = false;
        this.showScheduledExecutionJobResults = true;
        this.jobResults = this.scheduledExecutionJobResults;
        if (data.response.length < collection.size|| data.response.length === 0) {
          this.moreData = false;
        } else {
          this.moreData = true;
        }
      } else {
        this.toastr.warning(data.message);
        this.toggleExecutionJobResults = true;
        this.showScheduledExecutionJobResults = false;
        this.scheduledExecutionJobResults = null;
        this.moreData = false;
      }
    });
  }

  getExecutionEntityType(moduleType: string) {
    let entityType: string;

    switch (moduleType) {
      case 'ENDPOINT':
        entityType = 'END_POINT';
        break;

      case 'TESTCASE':
        entityType = 'TEST_CASE';
        break;

      case 'TESTSUITE':
        entityType = 'TEST_SUITE';
        break;

      case 'MASTERSUITE':
        entityType = 'MASTER_SUITE';
        break;

      default:
        entityType = null;
        break;
    }

    return entityType;
  }
  
  editSchedule(scheduledExecution: any) {
    this.isEdit = true;
    const modalRef = this.modalService.open(ScheduleFormComponent, {
      ariaLabelledBy: "modal-basic-title",
      backdrop: "static",
      windowClass: "confirm-modal",
      centered: true,
      size: "xl",
    });

    const data = {
      moduleType: this.moduleType,
      moduleDetails: this.moduleDetails,
      minDate: this.minDate,
      child: this.child,
      isEdit: this.isEdit,
    };

    modalRef.componentInstance.fromParent = data;
    modalRef.componentInstance.selectedScheduledExecution = scheduledExecution;
    modalRef.componentInstance.scheduledExecutionTrigger.subscribe(() => {
      this.getScheduledExecutions();
      this.isAllScheduleSelected = false;
      this.setDeleteAll = false;
    });
    return modalRef.result;
  }

  deleteSchedule(id: any) {
       this.sharedUtilService.openConfirmDialog(constants.deleteMessage, false).then((result) => {
      if (result) {
        this.scheduleService.deleteSchedule(id).subscribe(data => {
              if (data.code === 200) {
                this.getScheduledExecutions();
                this.toastr.success(data.message);
              } else {
                this.toastr.error(data.message);
              }
            });
      }
    });
    
   
  }

  showCronList(): void {
    const modalRef = this.modalService.open(CronExpressionModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'confirm-modal',
      centered: true,
      size: 'lg'
    });
  }

  loadMore(page: number) {
    this.page = page +1 ;
    if (this.filterForm.controls.executionStatus.value === null) {
      this.getScheduledExecutionResults();
    } else {
      this.getScheduledExecutionResultsByStatus();
    }
  }

  refreshSchedule() {
    if (this.filterForm.controls.executionStatus.value === null) {
      this.getScheduledExecutionJobResults(this.selectedScehduleId);
    } else {
      this.getScheduledExecutionJobResultsByStatus(this.selectedScehduleId);
    }
  }

  filterByStatus() {
    this.showScheduledExecutionJobResults = true;
    const collection = {
      page: (this.page - 1) || 0,
      size: this.pageSize || 5
    };
    if (typeof this.selectedScehduleId == "undefined") {
      this.toastr.warning("No Schedule is selected");
    } else {
      if (this.filterForm.controls.executionStatus.value === null) {
        this.getScheduledExecutionJobResults(this.selectedScehduleId);
      } else {
        this.getScheduledExecutionJobResultsByStatus(this.selectedScehduleId);
      }
    }
  }

  deleteMultipleSchedules(schedules: any[]) {
    const confirmMessage = constants.deleteMultipleSchedule;

    this.sharedUtilService.openConfirmDialog(confirmMessage, false).then((result) => {
      if (result) {
        const deletedSchedules = schedules.filter((schedule) => schedule.selected).map((schedule) => (schedule.id ));

        this.scheduleService.deleteMultipleSchedules(deletedSchedules).subscribe((data) => {
          if (data.code === 200) {
            this.toastr.success(data.message);
            this.getScheduledExecutions();
            this.isAllScheduleSelected = false;
            this.setDeleteAll = false;
          } else {
            this.toastr.error(data.message);
          }
        });
      }
    });
  }

  toogleAllSchedules() {
    this.isAllScheduleSelected = !this.isAllScheduleSelected;
    this.setDeleteAll = this.isAllScheduleSelected;
    this.scheduledExecutions.forEach((schedule) => {
      schedule.selected = this.isAllScheduleSelected;
    });
  }

  optionToggledSchedule(index: string | number) {
    this.scheduledExecutions[index].selected = !this.scheduledExecutions[index].selected;
    this.setDeleteAll = false;
    let count = 0;
    this.scheduledExecutions.forEach((schedule) => {
      if (schedule.selected) {
        this.setDeleteAll = true;
        count++;
      }
    });
    if (count === this.scheduledExecutions.length) {
      this.isAllScheduleSelected = true;
    } else {
      this.isAllScheduleSelected = false;
    }
  }

  openResult(scheduleJobResult: any, url: string) {
    const string1 = `${url}/${this.moduleDetails.id}/result?noSqlId=${scheduleJobResult.executionId}`;
    window.open(location.origin + "/" + this.location.prepareExternalUrl(string1));
  }
  onActiveChange(event, item) {
    const index = this.scheduledExecutions.findIndex(comp => comp.id === item.id);
    if (index !== -1) {
      item.active = event;
      this.scheduledExecutions[index] = item;
    }
    this.onActiveChangeTriggered = this.scheduledExecutions.some((item, index) => item.active !== this.originalComponents[index].active);
  }

  saveBulk() {
    const changedItems = this.getChangedItems();

    changedItems.forEach((item) => {
      delete item.selected;
    });

    this.scheduleService.saveBulkSchedules(changedItems).subscribe((data) => {
      if (data.code == 200) {
        this.onActiveChangeTriggered = false;
        this.isAllScheduleSelected = false;
        this.setDeleteAll = false;
        this.toastr.success(data.message);
        this.getScheduledExecutions();
      } else {
        this.toastr.error(data.message);
        this.onActiveChangeTriggered = false;
      }
    });
  }

  resetBulk() {
    this.getScheduledExecutions();
    this.onActiveChangeTriggered = false;
  }

  getChangedItems() {
    return this.scheduledExecutions.filter((item, index) => item.active !== this.originalComponents[index].active);
  }
}
